export default __webpack_public_path__ + "static/media/element_16.e7b9f124.jpg";